import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getForm, getActiveUser, getActiveSchoolLicense } from 'Store/reducers';
import {
  getPlanByLicense,
  getTrialLicenseByType,
} from 'Settings/pricing-options';

import Loading from 'Components/Loading';
import Payment from 'Containers/Payment/Payment';
import { withRouter, Redirect } from 'react-router';
import { ROUTES } from 'Settings/route-strings';
import { FORM_ID } from 'Containers/paymentForms/SubscriptionPurchaseForm';

class LoggedInPaymentPage extends React.Component {
  componentDidMount() {
    this.redirectToConfirmation();
  }

  componentDidUpdate(prevProps) {
    this.redirectToConfirmation(prevProps);
  }

  redirectToConfirmation(prevProps) {
    const { plan, history } = this.props;

    if (
      plan &&
      !plan.availableUpgrade &&
      (!prevProps || typeof prevProps.plan !== 'undefined')
    ) {
      history.replace({
        pathname: ROUTES.SETTINGS_SUBSCRIPTION_CONFIRMATION,
        state: { justSubscribed: false },
      });
    }
  }

  render() {
    const { activeUser, plan, form } = this.props;
    const { isPosting, message } = form || {};
    const isSuccess = !isPosting && message && message.type === 'success';

    if (!activeUser || !plan) return <Loading />;
    if (isSuccess) {
      return <Redirect to={ROUTES.SETTINGS_SUBSCRIPTION_CONFIRMATION} />;
    }
    return <Payment initialPlan={plan} user={activeUser} />;
  }
}

const mapStateToProps = (state, { location }) => {
  const licenses = getActiveSchoolLicense(state);
  let licenseType;
  if (licenses) licenseType = licenses[0].license_type;
  if (location.state && location.state.licenseType)
    licenseType = getTrialLicenseByType[location.state.licenseType];
  return {
    activeUser: getActiveUser(state),
    plan: licenseType ? getPlanByLicense(licenseType) : undefined,
    form: getForm(state, FORM_ID),
  };
};

LoggedInPaymentPage.propTypes = {
  plan: PropTypes.object,
  activeUser: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.shape({
    state: PropTypes.object,
  }),
};

export default withRouter(connect(mapStateToProps, false)(LoggedInPaymentPage));
